var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Com_12"},[_c('title1',{attrs:{"type":"2","title":"各时段发电效率"}}),_c('div',{staticClass:"Com_12_bottom",staticStyle:{"width":"565px","height":"364px"}},[(_vm.showcdata)?_c('MyEcharts',{attrs:{"id":'Com_12123123',"options":_vm.cdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }